// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"07432d27","115":"bf1ab18d","164":"0c5f69a3","204":"3c713c43","276":"5dcbf4ab","416":"94925bad","569":"ae13c7f6","778":"3e703e56","791":"89c36195","847":"a03a711c","906":"6d93c305"}[chunkId] + ".chunk.js";
};